/* eslint-disable no-console */
import React from 'react'
import { string, func, number, bool, oneOfType } from 'prop-types'
import Select from 'react-select'
import { Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import Icon from 'Pods/Shared/Icon/Icon'
import InputFieldWithPrefix from 'Pods/Shared/InputFieldWithPrefix'
import TextareaField from 'Pods/Shared/TextareaField'

function PricingAndLicenseArea({
  price = '',
  handleDetailChange,
  license,
  isFree,
  handleInputChange,
  handleInputBlur,
  errorFor,
  onFreeModelTrigger,
  customLicense,
  showErrors,
}) {
  function renderLicenseSelect() {
    const licenseOptions = isFree
      ? I18n.translate('publisher.licenses_free')
      : I18n.translate('publisher.licenses_paid')

    if (!licenseOptions) {
      return null
    }

    return (
      <div className="col-6 col-sm-5 col-md-4">
        <div className="form-group form-group-grey">
          <label>
            License <b>*</b>
          </label>
          <Select
            className="Select-outline"
            id="license-select"
            options={licenseOptions}
            onChange={(data) => handleDetailChange('license', data.value)}
            value={license}
            searchable={false}
            clearable={false}
          />
        </div>
      </div>
    )
  }

  return (
    <div className="publisher-area publisher-area--pricing-and-license">
      <div className="card">
        <div className="l-inner">
          <div className="section-heading">
            Pricing and license
            <Tooltip
              id="license-tooltip"
              content={I18n.translate('tooltips.publisher.license_html')}
              tooltipClassName="tooltip--is-list tooltip--licenses"
              html
            >
              <Icon type={['fas', 'info-circle']} color="grey" className="ml-5" />
            </Tooltip>
          </div>

          <div className="row">
            <div className="col-6 col-sm-5 col-md-4 pricing-section">
              <InputFieldWithPrefix
                label="Price"
                id="price"
                name="price"
                type="number"
                prefix="$"
                step="any"
                required
                simpleError
                disabled={isFree}
                errorText={errorFor('price')}
                showError={showErrors}
                value={price}
                formClassName="form-group-grey"
                inputClassName="form-control-grey"
                onChange={handleInputChange}
                onBlur={handleInputBlur}
              />

              <div className="pricing-section__free-check">
                <input
                  type="checkbox"
                  id="free-model"
                  className="checkbox"
                  checked={isFree}
                  onChange={onFreeModelTrigger}
                />
                <label htmlFor="free-model">Share for free</label>
              </div>

              <span className="separator separator--absolute" />
            </div>

            {renderLicenseSelect()}

            {['custom', 'custom_no_ai'].includes(license) && (
              <div className="col-12 custom-license-section">
                <TextareaField
                  label={license === 'custom_no_ai' ? 'Custom license, no AI' : 'Custom license'}
                  id="customLicense"
                  name="custom_license"
                  required
                  rows={5}
                  errorText={errorFor('customLicense')}
                  showError={showErrors}
                  value={customLicense}
                  formClassName="form-group-grey"
                  inputClassName="form-control-grey"
                  onChange={handleInputChange}
                  onBlur={handleInputBlur}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

PricingAndLicenseArea.propTypes = {
  handleInputChange: func.isRequired,
  handleInputBlur: func.isRequired,
  errorFor: func.isRequired,
  handleDetailChange: func.isRequired,
  onFreeModelTrigger: func.isRequired,
  price: oneOfType([number, string]),
  isFree: bool.isRequired,
  license: string.isRequired,
  customLicense: string.isRequired,
  showErrors: bool.isRequired,
}

export default PricingAndLicenseArea
